import React from 'react';
import { ClockIcon, MinimizeIcon, PackageXIcon, SlidersHorizontalIcon, TimerIcon, UsersIcon } from 'lucide-react';
import { SectionHeading } from '../SectionHeading';
import { situations } from '../../data/salesContent';
const icons = [PackageXIcon, MinimizeIcon, UsersIcon, ClockIcon, TimerIcon, SlidersHorizontalIcon];
const iconColors = ['text-pumpkin', 'text-plum-light', 'text-lime', 'text-pumpkin', 'text-plum-light', 'text-lime'];
export function SituationsSection() {
  return <section className="border-t border-line bg-navy py-8 sm:py-12" aria-labelledby="situations-title" data-id="element-165" data-mp="3gfdl7zmu2gsk">
      <div className="mx-auto max-w-7xl px-5 sm:px-8" data-id="element-166" data-mp="32gdv0njo9tua">
        <div id="situations-title" data-id="element-167" data-mp="32hox8ixgytja">
          <SectionHeading title={<>
                Whatever Your Gym Looks Like Today,{' '}
                <span className="text-pumpkin" data-id="element-169" data-mp="10pix9q5wnkkx">There’s a Way to Use It.</span>
              </>} data-id="element-168" data-mp="37ep3ouy8dyax" />
        </div>

        <ul className="mt-5 grid grid-cols-2 gap-2.5 lg:grid-cols-3 lg:gap-3" data-id="element-170" data-mp="15msuhrzjd0jb">
          {situations.map((s, i) => {
          const Icon = icons[i];
          return <li key={s.question} className="flex h-full flex-col rounded-2xl border border-line bg-night p-3.5 sm:p-5" data-id="element-171" data-mp="247skorwxrulq" data-mpi={i}>
                <Icon className={`h-5 w-5 ${iconColors[i]}`} aria-hidden="true" data-id="element-172" data-mp="2hz73axmxlts9" />
                <p className="mt-2.5 font-display text-[15px] font-extrabold uppercase leading-tight text-cream sm:text-xl" data-id="element-173" data-mp="2dzon2f6226vr">
                  {s.question}
                </p>
                <p className="mt-auto pt-2 text-[13px] leading-snug text-muted sm:text-sm" data-id="element-174" data-mp="1lahnrdys1d9g">{s.answer}</p>
              </li>;
        })}
        </ul>

        <p className="mx-auto mt-5 max-w-3xl text-center text-[15px] leading-relaxed text-muted" data-id="element-175" data-mp="1z74lvk2gu9gy">
          Designed for real gyms — not perfect spaces, unlimited equipment or unlimited planning time.
        </p>
      </div>
    </section>;
}